import React from 'react'

import Link from '@Pure/Link'

export default function PrivateSaleLink ({ private_sale, ...props })
{
	if (!private_sale) return null;

	return (
		<Link href={ '/VP-' + private_sale.slug } className="c-private-sale-link">

			{
				props.title ?
				(
					<div className="c-title c-title--v2 u-margin-top-0">
						<h2 className="c-title__txt">
							Vente privée
						</h2>
					</div>
				)
				: undefined
			}

			<div className="c-private-sale-link__text">
				{ private_sale.title }
			</div>

		</Link>
	);
}